// @core/api/endpoints/localization/index.ts
// Auto-generated by corebuilder. DO NOT EDIT.
import { ApproveTranslation } from './approve_translation';
import { BulkExportTranslations } from './bulk_export_translations';
import { BulkImportTranslations } from './bulk_import_translations';
import { CreateGlossaryEntry } from './create_glossary_entry';
import { CreateLocale } from './create_locale';
import { CreateNamespace } from './create_namespace';
import { CreateTranslationKey } from './create_translation_key';
import { DeleteGlossaryEntry } from './delete_glossary_entry';
import { DeleteLocale } from './delete_locale';
import { DeleteTranslationKey } from './delete_translation_key';
import { GetLocale } from './get_locale';
import { GetMissingTranslations } from './get_missing_translations';
import { GetNamespace } from './get_namespace';
import { GetPlatformLocaleConfig } from './get_platform_locale_config';
import { GetTranslation } from './get_translation';
import { GetTranslationBundle } from './get_translation_bundle';
import { GetTranslationStats } from './get_translation_stats';
import { ListGlossaryEntries } from './list_glossary_entries';
import { ListLocales } from './list_locales';
import { ListNamespaces } from './list_namespaces';
import { ListTranslationKeys } from './list_translation_keys';
import { ListTranslations } from './list_translations';
import { ReviewTranslation } from './review_translation';
import { SearchTranslationKeys } from './search_translation_keys';
import { SetTranslation } from './set_translation';
import { UpdateGlossaryEntry } from './update_glossary_entry';
import { UpdateLocale } from './update_locale';
import { UpdatePlatformLocaleConfig } from './update_platform_locale_config';
import { UpdateTranslationKey } from './update_translation_key';

// Re-export individual endpoints
export {
  ApproveTranslation,
  BulkExportTranslations,
  BulkImportTranslations,
  CreateGlossaryEntry,
  CreateLocale,
  CreateNamespace,
  CreateTranslationKey,
  DeleteGlossaryEntry,
  DeleteLocale,
  DeleteTranslationKey,
  GetLocale,
  GetMissingTranslations,
  GetNamespace,
  GetPlatformLocaleConfig,
  GetTranslation,
  GetTranslationBundle,
  GetTranslationStats,
  ListGlossaryEntries,
  ListLocales,
  ListNamespaces,
  ListTranslationKeys,
  ListTranslations,
  ReviewTranslation,
  SearchTranslationKeys,
  SetTranslation,
  UpdateGlossaryEntry,
  UpdateLocale,
  UpdatePlatformLocaleConfig,
  UpdateTranslationKey,
};

// Namespace export for convenient usage
export const localizationApi = {
  ApproveTranslation,
  BulkExportTranslations,
  BulkImportTranslations,
  CreateGlossaryEntry,
  CreateLocale,
  CreateNamespace,
  CreateTranslationKey,
  DeleteGlossaryEntry,
  DeleteLocale,
  DeleteTranslationKey,
  GetLocale,
  GetMissingTranslations,
  GetNamespace,
  GetPlatformLocaleConfig,
  GetTranslation,
  GetTranslationBundle,
  GetTranslationStats,
  ListGlossaryEntries,
  ListLocales,
  ListNamespaces,
  ListTranslationKeys,
  ListTranslations,
  ReviewTranslation,
  SearchTranslationKeys,
  SetTranslation,
  UpdateGlossaryEntry,
  UpdateLocale,
  UpdatePlatformLocaleConfig,
  UpdateTranslationKey,
};
